import { PriceRange, PriceViewState } from '@/components/molecules/item/price/model/item-price-view'
import { log } from '@/log'
import { ApiProductclass, defaultSalePriceDisplayType, SalePriceDisplayType } from '@/models/api/productclass'

export function convertToViewState(fku: ApiProductclass): PriceViewState {
  const basePrice = {
    withTax: fku.price.getPriceAfterTax(),
    withoutTax: fku.price.getPrice(),
    range: fku.price.hasRange ? PriceRange.some() : PriceRange.none(),
    exists: fku.price.exists,
  }

  if (fku.isOnDiscount) {
    return {
      isOnDiscount: true,
      nonPaidMemberPrice: {
        ...basePrice,
        discountRate: fku.price.getDiscountRate(),
        discountAmount: fku.price.discountAmount,
        discountUnit: getSalePriceDisplayType(fku),
      },
      paidMemberPrice: null,
    }
  }

  return {
    isOnDiscount: false,
    nonPaidMemberPrice: basePrice,
    paidMemberPrice: null,
  }
}

function getSalePriceDisplayType(fku: ApiProductclass): SalePriceDisplayType {
  if (fku.root) {
    return fku.root.getSalePriceDisplayType
  }

  log.warn(
    `fku ${fku.id} does not have root, so cannot determine sale price display. ` +
    `fall back to ${defaultSalePriceDisplayType}.`
  )

  return defaultSalePriceDisplayType
}
